import React, { useEffect, useState } from 'react'
import { Col, Input, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import { saltContentOptions } from './constants'
import { useFormUtils } from 'views/shared/useFormUtils'
import PropTypes from 'prop-types'
import { isNotNumericDecimal } from 'context/Utilities'

const CannedBeansPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    SaltContent: item.SaltContent,
    PBContainerSize: item.PBContainerSize,
  })
  const methods = useFormContext()
  const { setSelectReviewer, onChangeReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { SaltContent, PBContainerSize } = item
      setPackaging({
        SaltContent,
        PBContainerSize,
      })
    }
    // eslint-disable-next-line
  }, [item])
  return (
    <>
      <Row>
        <Col xs={6}>
          <h6>Salt Content {asterisk}</h6>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={saltContentOptions}
            defaultValue={{
              label: packaging.SaltContent,
              value: packaging.SaltContent,
            }}
            name="SaltContent"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Salt Type'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="SaltContent"
              message={'⚠ This selection is required.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
          <br />
          <h6>Size {asterisk}</h6>
          <Controller
            as={Input}
            className="react-select primary"
            classNamePrefix="react-select"
            defaultValue={packaging.PBContainerSize}
            name="PBContainerSize"
            placeholder={'15 - 16 ounces'}
            control={methods.control}
            rules={{
              validate: containerSize =>
                containerSize >= 15 && containerSize <= 16,
              maxLength: { value: 5, message: '⚠ Size exceeds 5 characters.' },
            }}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChangeReviewer(item, event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="PBContainerSize"
              message={'⚠ Size must be between 15 - 16 ounces.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
          <br />
        </Col>
      </Row>
    </>
  )
}

CannedBeansPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default CannedBeansPackageReview
